import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';

const WidgetSizeSelector = ({ selectedSize, onSizeChange }) => {
  const sizeOptions = [
    {
      id: 'small',
      label: 'Klein',
      description: 'Kompakte Größe für minimale Störung',
      dimensions: '320px × 400px',
      preview: 'w-16 h-20'
    },
    {
      id: 'medium',
      label: 'Mittel',
      description: 'Ausgewogene Größe für die meisten Websites',
      dimensions: '380px × 500px',
      preview: 'w-20 h-24'
    },
    {
      id: 'large',
      label: 'Groß',
      description: 'Maximale Sichtbarkeit und Funktionalität',
      dimensions: '450px × 600px',
      preview: 'w-24 h-28'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-foreground">Widget-Größe</h3>
        <span className="text-sm text-muted-foreground">
          {sizeOptions?.find(s => s?.id === selectedSize)?.dimensions}
        </span>
      </div>
      <div className="grid gap-4">
        {sizeOptions?.map((option) => (
          <div
            key={option?.id}
            className={`
              relative p-4 border-2 rounded-lg cursor-pointer transition-all duration-200
              ${selectedSize === option?.id 
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50 hover:bg-muted/50'
              }
            `}
            onClick={() => onSizeChange(option?.id)}
          >
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <Checkbox
                  checked={selectedSize === option?.id}
                  onChange={() => onSizeChange(option?.id)}
                />
              </div>
              
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-medium text-foreground">{option?.label}</h4>
                  <div className={`
                    bg-muted border border-border rounded ${option?.preview}
                    flex items-center justify-center
                  `}>
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground mb-1">{option?.description}</p>
                <p className="text-xs text-muted-foreground font-mono">{option?.dimensions}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WidgetSizeSelector;